<template>
  <div class="my_img m-lr-11">
    <span
      class="title"
      :style="`flex: 0 0 ${titleWidth}px`"
    >{{ title }}</span>
    <!-- 折叠图标 icon 不能是背景 -->
    <template v-if="url">
      <div v-if="!showIconLibrary"
        class="img_box"
        :style="`background-image: url(${url})`"
        @click="change_img"
      >
        <div class="jz_edit_box_btn" >
          <i class="el-icon-refresh"></i>
          <span>{{$t('components_my_img_index_2313')}}</span>
        </div>
      </div>
      <div class="img_box" v-else @click="change_img">
        <img :src="url" alt="" class="img-icon">
        <i class="img_viewer_edit" :title="$t('components_my_img_index_2314')"></i>
      </div>
    </template>
    <!-- <div v-if="url"
      class="img_box"
      :style="`background-image: url(${url})`"
      @click="change_img"
    >
      <div class="jz_edit_box_btn">
        <i class="el-icon-refresh"></i>
        <span>更换</span>
      </div>
    </div> -->
    <div v-else
      class="img_box addImg"
      :style="`background-image: url(${forMatImg().str1})`"
      @click="change_img"
    >
<!--      <div class="jz_edit_box_btn">
        <i class="el-icon-refresh"></i>
        <span>更换</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'
import imgadd from '@/assets/image/imgadd.jpg';
import imgadd_tc from '@/assets/image/imgadd_tc.jpg';
import imgadd_en from '@/assets/image/imgadd_en.jpg';

export default {
  name: 'my_img',
  props: {
    title: {
      type: String,
      default: i18n.t('view_back_top_edit_96')
    },
    titleWidth: { // 组件的标题
      type: String,
      default: '40'
    },
    imgUrl: {
      type: String,
      default: ''
    },
    // 是否显示图标库
    showIconLibrary: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    url (val) {
      this.$emit('update:imgUrl', val)  // 双向数据绑定
    },
    imgUrl (val) {
      this.url = val
    },
  },
  data () {
    return {
      url: this.imgUrl,
      // init_url: '',
      imgadd,
      imgadd_tc,
      imgadd_en
    }
  },
  methods: {
    change_img () {
      this.$store.commit('image_upload/set_fileType', 1)
      this.$store.commit('image_upload/set_fileLimit', 1)
      this.$store.commit("image_upload/set_showTag", true)

      this.$store.commit("image_upload/set_showIconLibrary", this.showIconLibrary);// 是否显示图标库
      if(this.showIconLibrary) {
        this.$store.commit("image_upload/set_selectLine", 1);
        this.$store.commit("image_upload/set_sePicTab", 'icon');
      }

      this.$store.state.image_upload.imgFile = (e) => {
        this.url = e[0].filePath
      }
    },
    forMatImg() {
      let str1 = this.imgadd;
      if (this.$store.state.app.web_language_wm == 'en') {
        str1 = this.imgadd_en
      } else if(this.$store.state.app.web_language_wm == 'tc') {
        str1 = this.imgadd_tc
      }
      return { str1 }
    }
  }
}
</script>

<style lang="scss" scoped>
.my_img {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: top;
  margin-bottom: 8px;
  .title {
    display: inline-block;
    font-size: 13px;
    text-align: right;
    overflow: hidden;
    height: 32px;
    line-height: 32px;
  }
  .img_box {
    position: relative;
    flex: 1;
    margin-left: 10px;
    height: 160px;
    border: 1px dashed transparent;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    .img_viewer_edit{
      display:block;
    }
    &:hover {
      border-color: #6d83d6;
    }
    &.addImg{
      background-size: auto;
      background-color: #617fef;
    }
    .jz_edit_box_btn {
      position: absolute;
      right: 0;
      bottom: 0;
      // width: 60px;
      width: auto;
      padding: 0 6px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      font-size: 14px;
      color: #fff;
      background: rgba(0, 120, 215, 0.9);
      cursor: pointer;
      i {
        display: inline-block;
        vertical-align: middle;
        width: 16px;
        height: 16px;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_img/index.vue